export enum DOCUMENT_SOURCE_CODES {
	WEB_UPLOAD = 'web',
	EMAIL = 'email',
	FAX = 'fax',
	DATA_SHARE_PROVIDER_DOCUMENT = 'dspro'
}
